import memoize from 'memoize-one';
import get from '../helpers/get';

const makeCountdownSelector = key => (
  (state, sliceId, itemIndex) => get(state, [
    'countdown',
    typeof itemIndex === 'number' ? `${sliceId}@${itemIndex}` : sliceId,
    key,
  ])
);
export const getCountdownUntil = makeCountdownSelector('until');
export const getCountdownDays = makeCountdownSelector('days');
export const getCountdownHours = makeCountdownSelector('hours');
export const getCountdownMinutes = makeCountdownSelector('minutes');
export const getCountdownSeconds = makeCountdownSelector('seconds');

export const hasActiveCountdown = (state, sliceId, itemIndex) => !!(
  getCountdownDays(state, sliceId, itemIndex)
  || getCountdownHours(state, sliceId, itemIndex)
  || getCountdownMinutes(state, sliceId, itemIndex)
  || getCountdownSeconds(state, sliceId, itemIndex)
);

export const hasActiveCountdowns = memoize(state => !!Object.keys(state.countdown).find(
  key => hasActiveCountdown(state, key),
));
